import { useCallback } from "react";

export default function useRadioGroup(props) {
  const { isDisabled, isInvalid, onChange: onChangeProp, name, value } = props;

  const handleChange = useCallback(
    (e) => {
      if (isDisabled) {
        e.preventDefault();
        return;
      }

      // Return the value from the event, if there is one.
      let valueToReturn = e;
      if (e?.target.value) {
        valueToReturn = e.target.value;
      }

      onChangeProp?.(valueToReturn);
    },
    [isDisabled, onChangeProp]
  );

  /**
   * Returns props which can be passed to a group of radio elements.
   * Use this when using custom elements for radio buttons.
   */
  const getRadioProps = useCallback(
    (passedProps = {}) => ({
      ...passedProps,
      isChecked: value !== null ? passedProps.value === value : undefined,
      name,
      onChange: handleChange,
    }),
    [handleChange, name, value]
  );

  return {
    getRadioProps,
    isDisabled,
    isInvalid,
    name,
    onChange: handleChange,
    value,
  };
}
